import { usePrivilegesStore } from '@/stores/privileges';

const DEFAULT_DENIED = 'You do not have permission to do this.';

/**
 * Guard a click or submit handler.
 *
 * This is a **user-experience** check, not a security one: it stops someone
 * starting an action the server will refuse. The API re-checks the same
 * permission on every request, so a user who bypasses this reaches a 403 rather
 * than data. In the legacy system the relationship was the other way round —
 * 56 of 60 privileges were enforced only by hiding a button.
 *
 * @param {string} permission A scope string from PRIVILEGES in @/constants/privileges
 * @param {string} [message]  Optional custom text
 * @returns {boolean}
 */
export function assertPrivilegeOrAlert(permission, message = DEFAULT_DENIED) {
  const store = usePrivilegesStore();

  if (!store.effectiveGranted(permission)) {
    // Kept as a native alert for now so this stays a drop-in replacement at all
    // 20 call sites; the toast treatment lands with the component rework.
    alert(message);
    return false;
  }

  return true;
}

export default assertPrivilegeOrAlert;
